import React from 'react';
import Button from '@atlaskit/button/standard-button';
import { Box, xcss } from '@atlaskit/primitives';
import EmptyState from '@atlaskit/empty-state';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import TwoFaIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/twofa/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { ErrorDisplay } from '../../common/ui/error-display/index.tsx';
import { loginViaRedirectUrl } from '../../common/utils/index.tsx';
import { messages } from './messages.tsx';

type Props = {
	loginRedirectUrl?: string;
};

const ErrorImage = () => (
	<Box
		xcss={[imageWrapperStyles, fg('replace_error_display_with_empty_state') && illustrationStyles]}
	>
		<TwoFaIllustration width={160} height={134} alt="" />
	</Box>
);

export const AuthenticationErrorView = ({ loginRedirectUrl }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return fg('replace_error_display_with_empty_state') ? (
		<EmptyState
			testId="issue-view-errors.ui.authentication-error-view.authentication-error-view"
			header={formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.authErrorHeaderIssueTermRefresh
					: messages.authErrorHeader,
			)}
			renderImage={() => <ErrorImage />}
			primaryAction={
				loginRedirectUrl && (
					<Button
						appearance="primary"
						onClick={() => loginViaRedirectUrl(loginRedirectUrl)}
						interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view.button"
					>
						{formatMessage(messages.authButton)}
					</Button>
				)
			}
		/>
	) : (
		<ErrorDisplay
			header={formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.authErrorHeaderIssueTermRefresh
					: messages.authErrorHeader,
			)}
			image={<ErrorImage />}
		>
			{loginRedirectUrl && (
				<Button
					appearance="primary"
					onClick={() => loginViaRedirectUrl(loginRedirectUrl)}
					interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view.button"
				>
					{formatMessage(messages.authButton)}
				</Button>
			)}
		</ErrorDisplay>
	);
};

const imageWrapperStyles = xcss({
	marginBottom: 'space.200',
});

const illustrationStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
